var _mask, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 3,
    width: 8,
    height: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 3H11.9999V12.9997H4V3Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.692 11.571H8.684C9.198 11.571 9.597 11.434 9.881 11.158C10.166 10.883 10.308 10.493 10.308 9.988C10.308 9.494 10.166 9.113 9.881 8.847C9.597 8.581 9.198 8.448 8.684 8.448H5.692V11.571ZM5.692 7.187H8.453C8.86 7.187 9.198 7.068 9.468 6.83C9.739 6.592 9.875 6.249 9.875 5.801C9.875 5.297 9.754 4.942 9.509 4.736C9.266 4.531 8.914 4.428 8.453 4.428H5.692V7.187ZM4 3H8.697C9.564 3 10.258 3.205 10.782 3.616C11.305 4.027 11.567 4.648 11.567 5.479C11.567 5.983 11.447 6.415 11.208 6.774C10.969 7.134 10.629 7.411 10.186 7.607V7.635C10.782 7.766 11.233 8.058 11.54 8.51C11.846 8.964 12 9.531 12 10.212C12 10.605 11.932 10.971 11.797 11.312C11.662 11.653 11.45 11.947 11.161 12.195C10.872 12.442 10.502 12.638 10.051 12.782C9.6 12.927 9.063 13 8.44 13H4V3Z",
    fill: "#73777C"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/bold.9ded531010c765b2c96d7638a16e899a.svg";
export { ForwardRef as ReactComponent };